module.exports = __webpack_public_path__ + "img/logo.d431d681.png";